module.exports = __webpack_public_path__ + "static/media/alert-circle-red.711e52a2.svg";